module.exports = __webpack_public_path__ + "media/fonts/sovremennic/SovremennicCondensed-Regular-3735095135bed651577f6c0a9b0bbe97.woff2";